import { createAction } from 'redux-actions';
import { reduxKey } from '../../constants';
import { createNetworkRequestActionSet } from '../utils';

export const setChangeEmailWidgetEmail = createAction(
  `${reduxKey}.SET_CHANGEEMAIL_WIDGET_EMAIL`,
  (email: string) => ({ email })
);

export const setChangeEmailWidgetPassword = createAction(
  `${reduxKey}.SET_CHANGEEMAIL_WIDGET_PASSWORD`,
  (password: string) => ({ password })
);

export const {
  submit: saveChangeEmail,
  success: saveChangeEmailSuccess,
  failure: saveChangeEmailFailure,
} = createNetworkRequestActionSet(reduxKey, 'SAVE_CHANGEEMAIL');
